export default __webpack_public_path__ + "static/media/ab-img.4094d0d4.png";